import ja from 'locale/ja.generated.json';
import {useMemo, useState} from 'react';
import {addLocale, useLocale as setLanguage} from 'ttag';
import {TTagTranslations} from 'ttag/dist/config';
import {Locale} from 'types';
import getPreferredLanguage from 'utils/locale';

const translations: Record<string, TTagTranslations> = {
    ja,
};

Object.entries(translations).forEach(([locale, data]) => {
    addLocale(locale, data);
});

const useLocale = () => {
    const [locale, setLocale] = useState<Locale>(getPreferredLanguage());

    return useMemo(() => {
        setLanguage(locale);

        return setLocale;
    }, [locale]);
};

export default useLocale;
